import { Component, Emit, Mixins, Prop, Watch } from 'vue-property-decorator'
import {
  Company,
  CompanyCollection,
  CompanyTypeEnum,
  IVendorPriceListEntry
} from '@/firestore'
import AuthMixin from '@/mixins/AuthMixin.vue'

@Component
export default class ProductSelector extends Mixins(AuthMixin) {
  @Prop({type: String, default: 'Description'})
  public labelText!: string

  @Prop({type: Object, required: true})
  public value!: IVendorPriceListEntry

  @Prop({type: Array, required: true})
  public priceListEntries!: IVendorPriceListEntry[]

  public internalValue: IVendorPriceListEntry | null = null

  public search: string = ''
  public filteredPriceListEntries: IVendorPriceListEntry[] = []

  public vendors: Company[] = []

  public rules = {
    entry: [
      (v: IVendorPriceListEntry | string) => (typeof v !== 'string' || !!v) || 'Please provide a ' + this.labelText,
      (v: IVendorPriceListEntry | string) => (!v || typeof v === 'string' || !!v.description) || 'Please provide a ' + this.labelText
    ]
  }

  get entries() {
    return this.internalValue && this.internalValue.description
      ? [this.internalValue, ...this.filteredPriceListEntries]
      : this.filteredPriceListEntries
  }

  public async mounted() {
    const companyService = await this.$companyService
    this.vendors = companyService.watchCompaniesByType(CompanyTypeEnum.VENDOR)
  }

  public async errorCaptured(error, componentInstance, errorInfo) {
    console.log(`error: ${error}`)
    console.log(`errorInfo: ${errorInfo}`)

  }

  public lookupVendorName(vendorCompanyId: string): string {
    const vendor = this.vendors.find((c: Company) => c.id === vendorCompanyId)
    return vendor ? vendor.displayName : ''
  }

  @Emit('updateEntry')
  public updateEntry(entry: IVendorPriceListEntry | string) {
    return typeof entry === 'string' ? {...this.internalValue, description: entry} : entry
  }

  public comparator(a: IVendorPriceListEntry, b: IVendorPriceListEntry) {
    if (!b) {
      return false
    }
    return a.description === b.description && a.priceListId === b.priceListId
  }

  @Watch('search')
  public async updateVendorPriceListEntries(search: string) {
    if (!search) {
      return this.filteredPriceListEntries = []
    }

    this.filteredPriceListEntries = this.priceListEntries.filter((entry: IVendorPriceListEntry) => {
      if (!entry.description) {
        return false
      }

      return entry.description.toLowerCase().includes(search.toLowerCase())
        || entry.description.toLowerCase() === search.toLowerCase()
    })
  }

  @Watch('value', {immediate: true})
  public setValue(value: IVendorPriceListEntry) {
    if (value.description) {
      this.internalValue = value
    } else {
      this.internalValue = null
      this.search = ''
    }
  }
}
